import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createBlock as _createBlock, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/graphic/file.svg'
import _imports_1 from '@/assets/img/graphic/play.svg'
import _imports_2 from '@/assets/img/icons-img/folder2.svg'


const _withScopeId = n => (_pushScopeId("data-v-05591cc0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "msg-item__partner-img"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 1,
  class: "partner-name"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "time" }
const _hoisted_7 = { class: "photo-box-wrap" }
const _hoisted_8 = { class: "photo-box" }
const _hoisted_9 = { class: "photo-box-100" }
const _hoisted_10 = {
  key: 0,
  class: "reshare-indicator"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-share" }, null, -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { class: "time" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "photo-box-wrap" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "file-item" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: "photo"
    })
  ])
], -1))
const _hoisted_15 = { class: "title" }
const _hoisted_16 = {
  key: 0,
  class: "reshare-indicator"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-share" }, null, -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-image" }, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "description" }, null, -1))
const _hoisted_21 = { class: "time" }
const _hoisted_22 = { class: "photo-box-wrap" }
const _hoisted_23 = { class: "photo-box" }
const _hoisted_24 = { class: "photo-box-100" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "video-player--play",
  src: _imports_1,
  alt: "play icon"
}, null, -1))
const _hoisted_26 = {
  key: 0,
  class: "reshare-indicator"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-share" }, null, -1))
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = { class: "time" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "folder-item" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "folder-item__img",
    src: _imports_2,
    alt: "folder"
  })
], -1))
const _hoisted_31 = { class: "title" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-image" }, null, -1))
const _hoisted_33 = { class: "photo-box-wrap" }
const _hoisted_34 = { class: "photo-box" }
const _hoisted_35 = { class: "photo-box-1" }
const _hoisted_36 = {
  key: 0,
  class: "video-player--play",
  src: _imports_1,
  alt: "play icon"
}
const _hoisted_37 = { class: "photo-box-2" }
const _hoisted_38 = {
  key: 0,
  class: "video-player--play",
  src: _imports_1,
  alt: "play icon"
}
const _hoisted_39 = { class: "photo-box-3" }
const _hoisted_40 = {
  key: 0,
  class: "video-player--play",
  src: _imports_1,
  alt: "play icon"
}
const _hoisted_41 = {
  key: 1,
  class: "photo-box-number"
}
const _hoisted_42 = { class: "title" }
const _hoisted_43 = {
  key: 0,
  class: "reshare-indicator"
}
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-share" }, null, -1))
const _hoisted_45 = [
  _hoisted_44
]
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-tablet" }, null, -1))
const _hoisted_47 = { class: "description" }
const _hoisted_48 = { class: "time" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_lazy_image = _resolveComponent("app-lazy-image")!
  const _component_app_case_view_pop_up = _resolveComponent("app-case-view-pop-up")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["msg-item", {
    'msg-item--my': _ctx.isMy,
    'msg-item--show-name': _ctx.msg.showName,
    'msg-item--reshare-indicator': _ctx.reshareAllowed && (_ctx.photo || _ctx.video),
  }])
  }, [
    (_ctx.isGroup)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_ctx.msg.showName)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: _ctx.photoUrl,
                class: "img",
                alt: "partner photo"
              }, null, 8, _hoisted_2))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.msg.showName)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.msg.owner.firstName) + " " + _toDisplayString(_ctx.msg.owner.lastName), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.isMy ? 'my' : 'partner', _ctx.msg.attachment ? 'w-100' : '', _ctx.photo || _ctx.video ? 'msg-item-photo' : ''])
    }, [
      (!_ctx.msg.attachment)
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
            _createElementVNode("span", {
              class: "span-linkify",
              innerHTML: _ctx.descriptionWithLink(_ctx.msg.content, _ctx.isMy)
            }, null, 8, _hoisted_5),
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.resolveTime(_ctx.msg.created)), 1)
          ]))
        : (_ctx.photo)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openMedia && _ctx.openMedia(...args)))
            }, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_app_lazy_image, {
                      url: _ctx.lowResUrlByViewTypeByUrl(_ctx.photo.fileUrl, _ctx.PHOTO_VIEW_TYPE.WHMED)
                    }, null, 8, ["url"])
                  ])
                ]),
                (_ctx.reshareAllowed)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.resolveTime(_ctx.msg.created)), 1)
            ]))
          : (_ctx.file)
            ? (_openBlock(), _createElementBlock("div", {
                key: 2,
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openFile && _ctx.openFile(...args)))
              }, [
                _hoisted_14,
                _createElementVNode("div", _hoisted_15, [
                  (_ctx.reshareAllowed)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, _hoisted_18))
                    : _createCommentVNode("", true),
                  _hoisted_19,
                  _createTextVNode(" " + _toDisplayString(_ctx.file.name), 1)
                ]),
                _hoisted_20,
                _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.resolveTime(_ctx.msg.created)), 1)
              ]))
            : (_ctx.video)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 3,
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openFile && _ctx.openFile(...args)))
                }, [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("div", _hoisted_24, [
                        _createVNode(_component_app_lazy_image, {
                          url: _ctx.lowResUrlByViewTypeByUrl(_ctx.video.previewUrl, _ctx.PHOTO_VIEW_TYPE.THUMB)
                        }, {
                          default: _withCtx(() => [
                            _hoisted_25
                          ]),
                          _: 1
                        }, 8, ["url"])
                      ])
                    ]),
                    (_ctx.reshareAllowed)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_26, _hoisted_28))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.resolveTime(_ctx.msg.created)), 1)
                ]))
              : (_ctx.folder)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 4,
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.viewFolder && _ctx.viewFolder(...args)))
                  }, [
                    _hoisted_30,
                    _createElementVNode("p", _hoisted_31, [
                      _hoisted_32,
                      _createTextVNode(" " + _toDisplayString(_ctx.folder.name), 1)
                    ])
                  ]))
                : (_ctx.iCase)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 5,
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.viewCase && _ctx.viewCase(...args)))
                    }, [
                      _createElementVNode("div", _hoisted_33, [
                        _createElementVNode("div", _hoisted_34, [
                          _createElementVNode("div", _hoisted_35, [
                            (_ctx.casePhoto1)
                              ? (_openBlock(), _createBlock(_component_app_lazy_image, {
                                  key: 0,
                                  url: _ctx.casePhoto1,
                                  class: _normalizeClass({'photo-box-file': _ctx.caseMedia[0]?.type === 'FILE'})
                                }, {
                                  default: _withCtx(() => [
                                    (_ctx.caseMedia[0]?.type === 'VIDEO')
                                      ? (_openBlock(), _createElementBlock("img", _hoisted_36))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                }, 8, ["url", "class"]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_37, [
                            (_ctx.casePhoto2)
                              ? (_openBlock(), _createBlock(_component_app_lazy_image, {
                                  key: 0,
                                  url: _ctx.casePhoto2,
                                  class: _normalizeClass({'photo-box-file': _ctx.caseMedia[1]?.type === 'FILE'})
                                }, {
                                  default: _withCtx(() => [
                                    (_ctx.caseMedia[1]?.type === 'VIDEO')
                                      ? (_openBlock(), _createElementBlock("img", _hoisted_38))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                }, 8, ["url", "class"]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_39, [
                            (_ctx.casePhoto3)
                              ? (_openBlock(), _createBlock(_component_app_lazy_image, {
                                  key: 0,
                                  url: _ctx.casePhoto3,
                                  class: _normalizeClass({'photo-box-file': _ctx.caseMedia[2]?.type === 'FILE'})
                                }, {
                                  default: _withCtx(() => [
                                    (_ctx.caseMedia[2]?.type === 'VIDEO')
                                      ? (_openBlock(), _createElementBlock("img", _hoisted_40))
                                      : _createCommentVNode("", true),
                                    (_ctx.iCase.photos.length > 3)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_41, "+" + _toDisplayString(_ctx.iCase.photos.length - 3), 1))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                }, 8, ["url", "class"]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_42, [
                        (_ctx.reshareAllowed)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_43, _hoisted_45))
                          : _createCommentVNode("", true),
                        _hoisted_46,
                        _createTextVNode(" " + _toDisplayString(_ctx.iCase.title), 1)
                      ]),
                      _createElementVNode("p", _hoisted_47, _toDisplayString(_ctx.iCase.description), 1),
                      _createElementVNode("span", _hoisted_48, _toDisplayString(_ctx.resolveTime(_ctx.msg.created)), 1)
                    ]))
                  : _createCommentVNode("", true)
    ], 2),
    (_openBlock(), _createBlock(_Teleport, { to: "#popup" }, [
      (_ctx.previewCase.show)
        ? (_openBlock(), _createBlock(_component_app_case_view_pop_up, {
            key: 0,
            onCancel: _cache[5] || (_cache[5] = ($event: any) => (_ctx.previewCase.show = false)),
            onDone: _cache[6] || (_cache[6] = ($event: any) => (_ctx.previewCase.show = false)),
            caseId: _ctx.previewCase.id,
            title: _ctx.previewCase.title,
            "photo-skeletons": _ctx.previewCase.photosAmount,
            "file-skeletons": _ctx.previewCase.filesAmount,
            "i-case": _ctx.iCase
          }, null, 8, ["caseId", "title", "photo-skeletons", "file-skeletons", "i-case"]))
        : _createCommentVNode("", true)
    ]))
  ], 2))
}